import { Button } from "@-/dev.improve.haniverse.components.ui.button";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { cn } from "@-/com.npmjs.cn";
import { Image } from "@-/com.npmjs.expo-image";
import { ActivityIndicator, Platform } from "@-/com.npmjs.react-native";
import { useTheme } from "@-/dev.improve.haniverse.lib.theme";

const APPLE_ICON_SOURCE = { uri: "https://img.clerk.com/static/apple.png?width=160" };

export type AppleSignInButtonProps = {
  compact?: boolean;
  /** Disables the button (e.g. while another auth request is in flight). */
  disabled?: boolean;
  onPress?: () => void;
  /** Shows a spinner and the pending label while Apple auth is in flight. */
  pending?: boolean;
};

export function AppleSignInButton({
  compact = false,
  disabled,
  onPress,
  pending,
}: AppleSignInButtonProps) {
  const colorScheme = useTheme();
  const iconColor = colorScheme !== "dark" ? "white" : "black";

  return (
    <Button
      accessibilityLabel="Sign in with Apple"
      accessibilityState={{ busy: pending, disabled }}
      className={cn(
        "h-14 w-full flex-row items-center justify-center gap-3 rounded-xs border-border/60 sm:h-14",
        "border-foreground bg-foreground active:bg-foreground/90 hover:web:bg-foreground/90",
        compact && "h-12 rounded-xs sm:h-12",
      )}
      disabled={disabled}
      onPress={onPress}
      // `sm` keeps the compact padding; the heights above also replace its `sm:h-8`.
      size="sm"
      variant="default"
    >
      {pending ? (
        <ActivityIndicator color={iconColor} size="small" />
      ) : (
        <Image
          className={cn("size-5", Platform.select({ web: "invert dark:invert-0" }))}
          source={APPLE_ICON_SOURCE}
          tintColor={Platform.select({
            native: iconColor,
          })}
        />
      )}
      <Text className="text-base font-semibold text-background">
        {pending ? "Signing in with Apple…" : "Sign in with Apple"}
      </Text>
    </Button>
  );
}
